import { Conversation, ChatMessage } from "../types/chat";
import { ModelMode } from "../config/modelConfig";
import { Workflow } from "../config/workflowConfig";
import { TroubleshootingOption } from "../config/troubleshootingConfig";

export function apiToConversation(raw: any): Conversation {
  return {
    conversationId: raw.conversation_id,
    customerName: raw.customer_name || undefined,
    caseId: raw.case_id || undefined,
    selectedWorkflow: (raw.selected_workflow || "chat") as Workflow,
    selectedModelMode: (raw.selected_model_mode || "normal") as ModelMode,
    selectedTroubleshootingOptions: (raw.selected_troubleshooting_options ||
      []) as TroubleshootingOption[],
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
    messages: (raw.messages || []).map(
      (m: any): ChatMessage => ({
        id: m.id,
        role: m.role,
        content: m.content,
        intent: m.intent,
        sources: m.sources || [],
        kb_status: m.kb_status,
        confidence_note: m.confidence_note,
        escalation_suggested: !!m.escalation_suggested,
        images: m.attachments || m.images || [],
        session_id: m.session_id || raw.conversation_id,
        timestamp: new Date(m.timestamp),
      })
    ),
  };
}

export function conversationToApi(c: Conversation) {
  return {
    conversation_id: c.conversationId,
    customer_name: c.customerName ?? null,
    case_id: c.caseId ?? null,
    selected_workflow: c.selectedWorkflow,
    selected_model_mode: c.selectedModelMode,
    selected_troubleshooting_options: c.selectedTroubleshootingOptions,
    created_at: c.createdAt,
    updated_at: c.updatedAt,
    messages: c.messages.map((m) => ({
      id: m.id,
      role: m.role,
      content: m.content,
      intent: m.intent ?? null,
      sources: m.sources ?? [],
      kb_status: m.kb_status ?? null,
      confidence_note: m.confidence_note ?? null,
      escalation_suggested: !!m.escalation_suggested,
      attachments: m.images ?? [],
      timestamp:
        m.timestamp instanceof Date
          ? m.timestamp.toISOString()
          : new Date(m.timestamp).toISOString(),
    })),
  };
}